function reworkDate(date, inLetter=false,format = 'fr', withHour = false, justHour = false){
    date = new Date(date);
    let days = date.getDate();
    let years = date.getFullYear();
    let month = date.getMonth()+1;
    let hour = date.getHours();
    let minutes = date.getMinutes();
    let monthLetter = getMonthInLetter(month);
    if(days < 10){
        days = "0" + days;
    }
    if(month < 10)
    {
        month = "0"+month;
    }
    if(inLetter){
        return days + ' ' + monthLetter + ' ' + years;
    }
    if(format === 'fr'){
        if(withHour){
            if(minutes < 10){
                minutes = "0" + minutes;
            }

            if(hour < 10){
                hour = "0" + hour;
            }
            return days + "/" + month + "/" + years + " " + hour + ":" + minutes;
        }

        if(justHour){
            if(minutes < 10){
                minutes = "0" + minutes;
            }

            if(hour < 10){
                hour = "0" + hour;
            }
            return hour + ":" + minutes;
        }
        return days + "/" + month + "/" + years;
    }else{
        return years + "-" + month + "-" + days;
    }


}

function getMonthInLetter(monthNumber){
    switch(monthNumber){
        case 1:
            return 'janvier';
            break;
        case 2 :
            return 'fevrier';
            break;
        case 3 :
            return 'mars';
            break;
        case 4:
            return 'avril';
            break;
        case 5 :
            return 'mai';
            break;
        case 6 :
            return 'juin';
            break;
        case 7 :
            return 'juillet';
            break;
        case 8 :
            return 'aout';
            break;
        case 9 :
            return 'septembre';
            break;
        case 10 :
            return 'octobre';
            break;
        case 11 :
            return 'novembre';
            break;
        case 12:
            return 'decembre';
            break;
        default :
            return '';
            break;
    }
}



export {reworkDate};
